import { useEffect, useState } from 'react';

const KEYBOARD_THRESHOLD_PX = 100;

/**
 * モバイル WebView でソフトキーボードが表示中かを判定する。
 *
 * VisualViewport API でレイアウトビューポートとの差分を監視し、
 * 一定以上縮んだ場合にキーボード表示中とみなす。
 */
export const useKeyboardVisible = (): boolean => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;

    const handler = () => {
      const heightDiff = window.innerHeight - vv.height;
      setIsVisible(heightDiff > KEYBOARD_THRESHOLD_PX);
    };

    vv.addEventListener('resize', handler);
    handler();

    return () => {
      vv.removeEventListener('resize', handler);
    };
  }, []);

  return isVisible;
};
